import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import MamakIntro from "../components/ServiceRegions/İntros/MamakIntro";
import DynamicImage from "../components/DynamicImage";


const MamakPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      {/* <AboutSection/> */}
      <DynamicImage />
      <MamakIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default MamakPage;
